import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
  signal,
} from '@angular/core';
import { MenuService } from './services/menu.service';
import { MenuItem } from 'primeng/api';
import { GlobalLoadingService } from 'app/core/services/loading.service';
import { BrandService } from 'app/core/services/brand.service';
import { LayoutService } from 'app/core/services/layout.service';
import { Observable } from 'rxjs';

/**
 * Admin Layout Component - Angular 19
 * Layout com sidebar colapsável
 */
@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AdminLayoutComponent implements OnInit {
  private readonly globalLoadingService = inject(GlobalLoadingService);
  private readonly menuService = inject(MenuService);
  private readonly brandService = inject(BrandService);
  private readonly layoutService = inject(LayoutService);

  menuItems$!: Observable<MenuItem[]>;
  loading$!: Observable<boolean>;

  isMenuCollapsed = signal(true);
  brandConfig = this.brandService.config;
  usarPaddingPadrao = this.layoutService.usarPaddingPadrao;

  ngOnInit() {
    this.menuItems$ = this.menuService.menuItems;
    this.loading$ = this.globalLoadingService.loading$;
  }
}
